export default __webpack_public_path__ + "static/2-e400a6c33ae604f16d110cfcb34ca2a3.webp";